import { useMemo } from 'react';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';
import { TaskInstance } from '@sdk/shiftTasks/types/apiTypes';

import { mapTaskInstanceAPIToUI } from '@web/shiftTasks/utils/mappers';

export const useShiftTaskMappers = () => {
  const personaCollection = usePersonaCollection();

  return useMemo(
    () => ({
      mapTaskInstanceAPIToUI: (taskInstance: TaskInstance) =>
        mapTaskInstanceAPIToUI(taskInstance, personaCollection),
    }),
    [personaCollection]
  );
};
